import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import type { Permission } from '@repo/shared-types';
import { useCan } from '../hooks/useCan';

/**
 * Route-level RBAC guard (THI-129). Same rule as PayrollPage's inline
 * `useCan(...) -> <Navigate to="/" replace />`, but wrapped AROUND the page
 * instead of living inside it — deliberately: an inline guard still lets the
 * page's own hooks fire first, and `fetchApi`'s `maybeToastForbidden` turns
 * the resulting 403 into a red "Chỉ quản trị viên..." toast on a redirect the
 * user never asked for. Mounting the guard above the page means the gated
 * request is never made at all.
 */
export function RequirePermission({ perm, children }: { perm: Permission; children: ReactNode }) {
  const allowed = useCan(perm);
  if (!allowed) return <Navigate to="/" replace />;
  return <>{children}</>;
}
